import { useEffect, useState } from 'react';
import API from '../../api';
import SearchSelect from '../../components/SearchSelect';

export default function EnseignantCopies() {
  const [evals, setEvals] = useState([]);
  const [selectedEval, setSelectedEval] = useState('');
  const [copies, setCopies] = useState([]);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    API.get('evaluations/').then((r) => {
      const all = r.data.results || r.data;
      setEvals(all.filter((e) => e.type_eval !== 'QCM'));
    });
  }, []);

  useEffect(() => {
    if (!selectedEval) { setCopies([]); setNotes([]); return; }
    API.get(`copies/?evaluation=${selectedEval}`).then((r) => setCopies(r.data.results || r.data));
    API.get(`notes/?evaluation=${selectedEval}`).then((r) => setNotes(r.data.results || r.data));
  }, [selectedEval]);

  const selectedEvalObj = evals.find((e) => e.id === selectedEval);

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-file-earmark-text" /> Copies soumises</h2>
      </div>

      <SearchSelect
        className="select-filter-wrap"
        value={selectedEval}
        onChange={(e) => setSelectedEval(e.target.value)}
        options={evals.map((ev) => ({ value: ev.id, label: `${ev.titre} (${ev.cours_titre})` }))}
        placeholder="-- Sélectionner une évaluation --"
      />

      {selectedEval && (
        <>
          {selectedEvalObj && (
            <div className="glass-card-static" style={{ marginTop: 16, marginBottom: 16 }}>
              <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: 14 }}>
                <strong>{selectedEvalObj.type_eval}</strong> — {selectedEvalObj.cours_titre} — Barème : /{selectedEvalObj.bareme}
              </p>
            </div>
          )}

          {copies.length === 0 ? (
            <div className="empty-state"><i className="bi bi-inbox" /><p>Aucune copie soumise pour cette évaluation</p></div>
          ) : (
            <div className="data-table-wrapper">
              <table className="data-table">
                <thead>
                  <tr><th>Étudiant</th><th>Soumise le</th><th>Statut</th><th>Fichier</th></tr>
                </thead>
                <tbody>
                  {copies.map((c) => {
                    const note = notes.find((n) => String(n.etudiant) === String(c.etudiant));
                    return (
                      <tr key={c.id}>
                        <td>{c.etudiant_nom}</td>
                        <td>{new Date(c.soumis_le).toLocaleString('fr-FR')}</td>
                        <td>
                          {note
                            ? (() => { const pct = note.bareme ? (note.valeur / note.bareme) * 20 : 0; const cls = pct >= 10 ? 'note-success' : pct >= 8 ? 'note-warning' : 'note-danger'; return <span className={`badge-status badge-published ${cls}`}><i className="bi bi-check-circle" /> {parseFloat(note.valeur).toFixed(2)}/{note.bareme}</span>; })()
                            : <span className="badge-status badge-draft">En attente</span>}
                        </td>
                        <td>
                          <a href={c.fichier_url || c.fichier} target="_blank" rel="noreferrer" className="btn btn-sm btn-secondary">
                            <i className="bi bi-download" /> Télécharger
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          <p style={{ marginTop: 12, color: 'var(--text-secondary)', fontSize: 13 }}>
            {copies.length} copie{copies.length > 1 ? 's' : ''} soumise{copies.length > 1 ? 's' : ''}
          </p>
        </>
      )}
    </div>
  );
}
